const judicialProcessCustomerFeedbackStyle = {
  centerText: {
    textAlign: "center"
  }
};

export default judicialProcessCustomerFeedbackStyle;
